import { withRouter } from "react-router-dom";

import { darken } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import PortalNavDrawer from "../ui/portalNavDrawer";
import BotpressPresentedLinks from "../widgets/botpressPresentedLinks";
import BotpressProducts from "../widgets/botpressProducts";

const BotpressSalesPortal = props => {
  const theme = useTheme();

  return (
    <Portal
      displayHeader={false}
      sx={{
        backgroundSize: "cover",
        backgroundColor: darken(theme.palette.commonground.main, 0.4),
      }}
    >
      <PortalAppBar title="Botpress Sales Portal" botpressStyle={true} />
      <PortalNavDrawer />
      <PortalGridContent hasNavDrawer>
        <Grid size={{ xs: 12 }}>
          <BotpressProducts minHeight={"0px"} />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <BotpressPresentedLinks minHeight={"0px"} />
        </Grid>

        {/* Product analytics / graphing widgets will also live here alongside
            Products and Presented Links. */}

        <Grid size={{ xs: 12, sm: 6, lg: 4 }} />
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(BotpressSalesPortal);
